import { useEffect } from "react";
import { IMG } from "@/lib/content";
import { FadeUp, Crosshair } from "@/components/Reveal";

const VALUES = [
  { n: "01", t: "ONLY THE BEST MAKES THE CUT", d: "We source from producers who can actually cut heavyweight cotton and sew a proper seam. If a piece doesn't pass our inspection, it never reaches a drop." },
  { n: "02", t: "SMALL, CONSIDERED RUNS", d: "No seasons for the sake of seasons. Limited quantities, sourced with intent — when a piece sells out, it's gone." },
  { n: "03", t: "FROM INDIA, FOR THE BOLD", d: "Curated in India, shipped across India, with free delivery on every order." },
];

export default function About() {
  useEffect(() => {
    document.title = "ABOUT — REQUIEM FEVER";
  }, []);

  return (
    <div className="bg-ink" data-testid="about-page">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8 sm:py-20">
        <FadeUp>
          <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-gold">THE LABEL</p>
        </FadeUp>
        <FadeUp delay={0.08}>
          <h1 className="mt-4 max-w-4xl font-display text-5xl leading-[0.9] tracking-[0.01em] text-bone sm:text-8xl">
            SOURCED FOR THE
            <br />
            UNCONVENTIONAL.
          </h1>
        </FadeUp>
        <FadeUp delay={0.16}>
          <p className="mt-8 max-w-xl text-sm leading-relaxed text-bone/70 sm:text-base">
            Requiem Fever is an independent label from India — and we don't manufacture clothes. We
            hunt them down. Every piece is sourced from the best producers in the game, then
            inspected by hand before it earns a place in a drop. The market is flooded with thin,
            mass-printed merch; we exist so you never have to settle for it. Distinctive pieces, bold
            details, uncompromising quality — a different kind of uniform for people who treat
            personal style as a statement.
          </p>
        </FadeUp>

        <div className="relative mt-16 grid gap-6 sm:mt-24 lg:grid-cols-12">
          <FadeUp className="relative lg:col-span-7">
            <div className="relative">
              <Crosshair className="-left-2 -top-2 border-l border-t" />
              <Crosshair className="-bottom-2 -right-2 border-b border-r" />
              <img src={IMG.hero} alt="Requiem Fever editorial" className="aspect-[16/10] w-full object-cover" loading="lazy" />
            </div>
          </FadeUp>
          <FadeUp delay={0.12} className="lg:col-span-5 lg:pt-16">
            <img src={IMG.whiteTeePhoto} alt="Requiem Fever campaign" className="aspect-[4/5] w-full object-cover" loading="lazy" />
          </FadeUp>
        </div>

        <div className="mt-20 grid gap-px border border-line bg-line sm:mt-28 sm:grid-cols-3">
          {VALUES.map((v, i) => (
            <FadeUp key={v.n} delay={i * 0.1} className="bg-ink p-8 sm:p-10">
              <p className="font-mono text-[10px] tracking-[0.3em] text-gold">{v.n}</p>
              <h3 className="mt-4 font-display text-2xl tracking-[0.05em] text-bone">{v.t}</h3>
              <p className="mt-3 text-sm leading-relaxed text-bone/60">{v.d}</p>
            </FadeUp>
          ))}
        </div>
      </div>
    </div>
  );
}
